import fs from "node:fs";

// A variable to cache the Docker status
let isDockerCached: boolean | undefined;

// Checks if the "/.dockerenv" file exists, indicating Docker environment
function hasDockerEnv () {
  try {
    fs.statSync( "/.dockerenv" );
    return true;
  } catch {
    return false;
  }
}

// Checks if the "/usr/local/bin/docker-entrypoint.sh" file exists, indicating Docker environment
function hasDockerEntry () {
  try {
    fs.statSync( "/usr/local/bin/docker-entrypoint.sh" );
    return true;
  } catch {
    return false;
  }
}

// Checks if the "/proc/self/cgroup" file contains "docker", indicating Docker cgroup
function hasDockerCGroup () {
  try {
    return fs.readFileSync( "/proc/self/cgroup", "utf8" ).includes( "docker" );
  } catch {
    return false;
  }
}

// Determines if the application is running inside a Docker container
export function isDocker () {
  if ( import.meta.client ) {
    isDockerCached = false;
  }

  if ( isDockerCached === undefined ) {
    isDockerCached = hasDockerEnv() || hasDockerCGroup() || hasDockerEntry();
  }

  return isDockerCached;
}
